import { apiFetch } from './client';

export interface PairExchangeResult {
  phone_token: string;
  phone_id: string;
  family_id: string;
  phones_connected: number;
  phones_limit: number | null;
}

export interface PairedPhoneRow {
  phone_id: string;
  label: string | null;
  paired_at: string;
  last_seen_at: string | null;
}

export async function exchangePair(body: {
  pair_token?: string;
  short_code?: string;
  label?: string;
}): Promise<PairExchangeResult> {
  return apiFetch<PairExchangeResult>('/v1/pair/exchange', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
}

export async function listPairedPhones(): Promise<{
  phones: PairedPhoneRow[];
  count: number;
  limit: number | null;
}> {
  return apiFetch('/v1/pair/phones');
}

export async function removeThisPhone(): Promise<void> {
  await apiFetch('/v1/pair/phones/me', { method: 'DELETE' });
}

export async function signOutAllPhones(): Promise<void> {
  await apiFetch('/v1/pair/signout-all', { method: 'POST' });
}
